<template>
  <div>
    <Checkin
      :label="'Colatura'"
      role="postazione-colatura-gesso"
    />
    <StuckWorkWarningProvider />
  </div>
</template>

<script>
import Checkin from '@/components/plaster/Checkin';
import StuckWorkWarningProvider from '@/components/StuckWorkWarningProvider.vue';

export default {
  name: "Pouring",
  components: {
    Checkin,
    StuckWorkWarningProvider,
  },
}
</script>
